const setLocalStorage = (value)=>{
    localStorage.setItem('value',value);
}

const getLocalStorage=(v)=>{
    
const value =localStorage.getItem('value');
return value;
}

export{
    setLocalStorage,
    getLocalStorage
}